module.exports = __webpack_public_path__ + "375a3b1920da847c3e42b8f56d3a9f2d.png";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/plugins/iCheck/minimal/pink.png
// module id = 311
// module chunks = 0